// Identificador estável: usa a sequência da ficha, também para ferramentas e RMM.
// Não depende do nome, da categoria nem da posição na listagem.
const codigoEquipamento = (id) => {
    const numero = Number(id);
    return Number.isSafeInteger(numero) && numero > 0 ? `EQ-${String(numero).padStart(6, '0')}` : '-';
};

export { codigoEquipamento };
export const ultimaVerificacaoEquipamento = (eq) => {
    const datas = (eq.categoria === 'rmm' ? [eq.rmm_ultimo_em] : [eq.dl50_ultimo_em, eq.dl50_ultima_verificacao])
        .filter(v => v && !Number.isNaN(new Date(v).getTime()));
    return datas.sort((a, b) => new Date(b) - new Date(a))[0] || null;
};
export const dataVerificacaoEquipamento = (eq) => {
    const data = ultimaVerificacaoEquipamento(eq);
    return data ? new Date(data).toLocaleDateString('pt-PT') : 'Sem registo';
};
